export const navData = [
  {
    title: "Home",
    href: "#home",
  },
  {
    title: "About",
    href: "#about",
  },
  {
    title: "Projects",
    href: "#projects",
  },
  {
    title: "Blogs",
    href: "#blogs",
  },
  {
    title: "Contact",
    href: "#contact",
  },
];
